const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 3.25a.75.75 0 0 0 0 1.5h1.25v14.5H9a.75.75 0 0 0 0 1.5h2.75v-8.043a.8.8 0 0 0 .25.043h9a.75.75 0 0 0 0-1.5h-9a.8.8 0 0 0-.25.043V3.25zM5.5 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path d="M7.5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/></svg>';
export {
  a as w
};
